import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../v2-theme.css';
import './Landing.css';

/**
 * Landing Page - Hands On The Fly
 * Matches index.html exactly
 */
const Landing = () => {
  const navigate = useNavigate();

  const handleRestaurantSignup = () => {
    navigate('/restaurant-register');
  };

  const handleWorkerSignup = () => {
    navigate('/worker-register');
  };

  const handleLogin = (userType) => {
    if (userType === 'restaurant') {
      navigate('/restaurant-login');
    } else if (userType === 'worker') {
      navigate('/worker-login');
    }
  };

  return (
    <div className="landing-page">
      <header className="landing-header">
        <div className="landing-header-content">
          <div className="landing-logo-container">
            <img src="/hotf-web-icon.png" alt="Hands On The Fly Logo" className="landing-logo" />
            <div>
              <h1 className="landing-title">Hands On The Fly</h1>
              <div className="landing-header-tagline">
                Your Back of House Solution for Last-Minute Staffing Needs
              </div>
            </div>
          </div>
          <div className="landing-nav-space">
            {/* Future navigation will go here */}
          </div>
        </div>
      </header>

      <main className="landing-main">
        <section className="landing-hero">
          <h2 className="landing-hero-heading">
            Kitchen Help...
            <span className="landing-hero-line2">On-The-Fly</span>
          </h2>
          <p className="landing-description">
            No-shows happen. Emergencies happen. People quit mid-shift. Connect restaurants with
            kitchen staff who can actually show up and work. Post a shift, fill a shift. That's it.
          </p>
        </section>

        <section className="landing-action-cards">
          <div className="landing-action-card">
            <h3>Restaurants</h3>
            <div className="landing-action-subtitle">
              Professional Kitchens & Licensed Establishments
            </div>
            <p>
              Post the shift. Position, pay, hours. Real kitchen workers will see it and claim it.
            </p>
            <button className="landing-btn landing-btn-restaurant" onClick={handleRestaurantSignup}>
              Hands Needed
            </button>
          </div>

          <div className="landing-action-card">
            <h3>Kitchen Staff</h3>
            <div className="landing-action-subtitle">
              Dishwashers, Prep Cooks, Line Cooks, Sous Chefs, Event Cooks, Head Chef, Banquet,
              Bartender, Barback
            </div>
            <p>Need work today? Browse shifts. Claim what works. Show up, do the job, get paid.</p>
            <button className="landing-btn landing-btn-worker" onClick={handleWorkerSignup}>
              Hands Available
            </button>
          </div>
        </section>

        <section className="landing-login-section">
          <h3>Already Have an Account?</h3>
          <div className="landing-login-buttons">
            <button className="landing-btn-login" onClick={() => handleLogin('restaurant')}>
              Restaurant Login
            </button>
            <button className="landing-btn-login" onClick={() => handleLogin('worker')}>
              Worker Login
            </button>
          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <p>&copy; 2025 Hands on the Fly. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Landing;
